<template>
  <div class="searchPage">
    <section class="gallery-wrap">
      <div class="container">
        <div class="searchbar-container">
          <form
            class="searchbar-wrapper"
            @submit.prevent="
              handleSearch();
              this.showSearchSuggestion = false;
            "
          >
            <input
              class="searchbar"
              type="text"
              placeholder="Search Here"
              v-model="searchText"
              @focus="triggerSuggestion()"
              @keydown.down="onArrowDown"
              @keyup.up="onArrowUp"
              @keydown.enter="onEnter"
            />

            <div class="search__suggestion" v-if="showSearchSuggestion">
              <img
                :src="require('../../assets/svg/crossBlack.svg')"
                alt="search"
                @click="showSearchSuggestion = false"
              />

              <span v-if="showNoSearchFound" class="search__suggestionSpan">
                No Search Found</span
              >
              <span
                v-else
                :class="
                  items.id === arrowCounter
                    ? 'search__suggestionActive'
                    : 'search__suggestionSpan'
                "
                v-for="items in searchFound.slice(0, 10)"
                :key="items.id"
                @click="
                  handleSearchItem(items.name);
                  handleSearch();
                "
                >{{ items.name }}</span
              >
            </div>

            <a-icon
              @click.prevent="handleSearch"
              type="search"
              class="search-icon"
              v-if="!showSearchLoading"
            />

            <div class="search__loading" v-if="showSearchLoading">
              <Loading />
            </div>

            <!-- <div v-if="showSearchLoading"><Loading /></div> -->
          </form>
        </div>

        <h1 class="vname">Search results for "{{ pageName || searchText }}"</h1>

        <div class="menu-list">
          <a-list
            :grid="{ gutter: 16, xs: 1, sm: 2, md: 3, lg: 4, xl: 4, xxl: 4 }"
            :loading="loading"
            :dataSource="filteredItems"
            :pagination="pagination"
            :key="1"
          >
            <a-list-item
              slot="renderItem"
              slot-scope="item"
              class="list-complete-item"
              :loading="loading"
            >
              <ProductNew v-bind:item="item" :key="item.id" />
            </a-list-item>
          </a-list>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { SearchService } from "../../services/items.service";
import { LocationId } from "../../services/storage.service";
import ProductNew from "../../views/Home/ProductFeature/ProductNew";
import Loading from "../../components/Loading/Loading.vue";
import axios from "axios";
import router from "../../router";

export default {
  name: "Search",
  components: {
    ProductNew,
    Loading,
  },
  data() {
    return {
      arrowCounter: -1,

      pageName: "",
      showFilterCat: 1,
      loading: true,
      categories: [],
      subCategories: [],
      items: [],
      allItems: [],
      visible1: false,
      currentTag: "",
      typeTag: "",
      searchText: "",
      showSearchLoading: true,
      pagination: {
        onChange: (page) => {
          window.scrollTo(0, 0);
        },
        pageSize: 20,
      },

      currentCat: "",
      showSearchSuggestion: false,
      searchFound: null,
      searchItems: [],
    };
  },
  created() {
    window.scrollTo(0, 0);
    this.triggerSuggestion();
    this.showSearchSuggestion = false;

    this.checkLocationIdInUrl();

    let that = this;

    if (LocationId.getLocationId() === null) {
      this.$confirm({
        title: "Please choose your delivery location",
        okText: "Pokhara",
        okType: "primary",
        cancelText: "Kathmandu",
        onOk() {
          that.updateLocationId(2);
        },
        onCancel() {
          that.updateLocationId(1);
        },
      });
    }

    this.checkParams();
    this.clearVariables();

    this.currentTag = this.currentTag.toLowerCase();

    if (LocationId.getLocationId() === null) {
      return;
    } else {
      this.loadServices();
    }


    

    document.title ="\"" +  this.pageName  +"\" | "+ this.$route.meta.title;




  },
  watch: {
    $route: function (n, o) {
      this.checkLocationIdInUrl();
      this.checkParams();
      this.loadServices();
      this.clearVariables();
      document.title ="\"" +  this.pageName  +"\" | "+ this.$route.meta.title;
    },

    locationId: function (newLocationId, oldLocationId) {
      this.loadServices();
    },
    searchText() {
      // this.showSearchSuggestion = true;
      this.triggerSuggestion();
    },
  },
  computed: {
    ...mapGetters(["locationId"]),
    filteredItems: function () {
      var filter = this.currentTag.toLowerCase();
      if (filter === "combo") {
        return this.items.filter(function (item) {
          return item.item_type.toLowerCase().indexOf(filter) !== -1;
        });
      } else {
        return this.items;
      }
    },
    emptyCategoryList: function () {
      return this.categories.filter(function (item) {
        return item.cat_id !== "";
      });
    },
    emptySubCategoryList: function () {
      let a = this;
      return this.categories.filter(function (item) {
        return item.name == a.currentTag;
      });
    },
  },
  methods: {
    ...mapActions(["setMinOrder", "updateLocationId"]),

    onArrowDown() {
      if (this.arrowCounter < this.searchFound.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },

    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter() {
      this.showSearchSuggestion = false;

      this._search = this.searchFound[this.arrowCounter];
      this.searchText = this._search.name;
      this.arrowCounter = -1;

      // console.log(this._search.name, "niran");
      // this.search(this._search.name);
    },

    triggerSuggestion() {
      this.searchFound = null;

      this.showSearchLoading = true;
      this.showSearchSuggestion = true;

      const _data = {
        loc_id: JSON.stringify(LocationId.getLocationId()),
        search: this.searchText,
      };

      axios
        .post("https://deus.khaanpin.com/appapi/top/search/", _data)
        .then((res) => {
          if (res.data.error == false) {
            this.searchFound = res.data.data;
            const data = res.data.data.forEach((item, i) => {
              item.id = i;
            });
            this.showSearchLoading = false;
            this.showNoSearchFound = false;
          } else {
            this.showNoSearchFound = true;
            this.showSearchLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    showFilter() {
      this.visible1 = true;
    },
    onClose() {
      this.visible1 = false;
    },
    handleChange(value) {
      return;
    },
    handleBlur() {
      return;
    },
    handleFocus() {
      return;
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    filterTags: function (tag) {
      this.items = this.allItems;
      this.currentTag = tag;
      this.typeTag = "";

      this.showFilterCat = 0;
    },
    filterTags2: function (tag) {
      this.items = this.allItems;

      this.typeTag = "";
      // this.showFilterCat = 0;
      this.currentCat = tag;
      this.secondFilter(tag);
    },
    secondFilter: function (tag) {
      this.typeTag = tag;
      if (tag === "") {
        this.items = this.allItems;
      } else {
        this.items = this.allItems.filter((item) => item.sub_cat_id === tag);
      }

      this.showFilterCat = 0;
    },

    checkParams: function () {
      //  console.log("::" + this.$route.params.slug )
      // this.page = this.$route;
      this.pageName = this.$route.query.q;

      // console.log("checkParams pageName", this.pageName);
      // console.log("checkParams page", this.page);

      if (this.$route.query.q != undefined) {
        this.hasV = 1;
        //if Number
        if (!isNaN(this.vName)) {
          // console.log("Number : " + Number(this.vName));
        }
        // endif NaN
        //if String
        else {
          // console.log("String : " + this.vName)
        }
        // end isnan strings
      } else {
        this.hasV = 0;
        // if (LocationId.getLocationId() == 1) {
        //   router.push("/ktm");
        // } else if (LocationId.getLocationId() == 2) {
        //   router.push("/pkr");
        // }
      }
    },

    checkLocationIdInUrl: function () {
      if (this.$route.params.loc == "ktm") {
        this.updateLocationId(1);
      } else if (this.$route.params.loc == "pkr") {
        this.updateLocationId(2);
      }
    },

    loadServices() {
      this.showSearchLoading = false;
      // this.allItems = "";
      this.showSearchSuggestion = false;
      this.loading = true;
      SearchService.getItems(
        parseInt(LocationId.getLocationId()),

        this.pageName
      )
        .then((data) => {
          // console.log(data, "search dataaaaaaaaaaaaaaaaaa");
          if (data.error == false) {
            (this.items = data.data), (this.allItems = data.data);
            // console.log(
            //   this.allItems,
            //   "search dataaaaaaaaaaaaaaaaaaaaaaaaaaaaaa"
            // );
            this.showSearchLoading = false;

            this.showSearchSuggestion = false;
            this.loading = false;
          } else {
            this.loading = false;
            this.showSearchLoading = false;
            this.showSearchSuggestion = false;

            this.items = [];
          }

          // this.searchFound = data.data;
          // this.showSearchSuggestion = false;

          // this.showSearchLoading = false;
        })
        .catch((err) => {
          this.items = [];
          this.loading = false;
          this.showSearchLoading = false;

          console.log(err);
        });

      // const data = this.allItems.filter((val) => {
      //   if (this.searchText === "") {
      //     return val && this.showSearchSuggestion == false;
      //   } else if (
      //     val.name.toLowerCase().includes(this.searchText.toLowerCase())
      //   ) {
      //     // this.showSearchSuggestion = true;
      //     return val;
      //   }
      // });
      // // console.log(this.showSearchSuggestion, "show searchsuggestion");
      // this.searchFound = data;
      // // console.log(this.searchFound, "helloooo search foundddddddddddddd");
    },

    clearVariables: function () {
      this.currentCat = "";
      this.currentTag = "";
      this.typeTag = "";
    },

    handleSearchItem(item) {
      this.showSearchSuggestion = false;
      this.searchText = item;
    },

    handleSearch() {
      // event.target.focus();
      this.loading = true;

      if (!this.searchText) {
        return;
      }
      this.showSearchSuggestion = false;

      if (LocationId.getLocationId() == 1) {
        this.showSearchSuggestion = false;

        this.$router.replace({
          name: "Search",
          params: { loc: "ktm" },
          query: { q: this.searchText },
        });
      } else if (LocationId.getLocationId() == 2) {
        this.$router.replace({
          name: "Search",
          params: { loc: "pkr" },
          query: { q: this.searchText },
        });
      }
      this.searchText = "";
    },
  },
  mounted() {
    this.showSearchSuggestion = false;
  },
};
</script>

<style lang="scss">
@import "@/styles/variables.scss";

.search__form {
  position: relative;
}

.search__loading {
  position: absolute;
  right: 0;
  margin-right: 12px;
}

.search__suggestion {
  position: absolute;
  display: flex;
  flex-direction: column;
  /* border: 1px solid black; */
  z-index: 20;
  width: 100%;
  margin: 10px 0;
  background-color: #f1f1f1;
  /* padding: 10px 8px; */
  border-radius: 10px;
  transition: ease 0.8s all;
  top: 85%;
  cursor: pointer;
}

.search__suggestion > img {
  height: 15px;
  margin-right: 10px;
  margin-top: 8px;
  position: absolute;
  right: 0;
  cursor: pointer;
}

.search__suggestionSpan {
  /* color: red; */
  color: #4b4b4b;
  /* margin: 2px 0; */
  letter-spacing: 0.6px;
  font-size: 14px;
  padding: 5px 25px;
  font-weight: bolder;

  font-family: "Montserrat", sans-serif;
}

.search__suggestionActive {
  color: #000000;
  background-color: #e2e2e2;

  letter-spacing: 0.6px;
  font-size: 14px;
  padding: 5px 25px;
  font-weight: bolder;

  font-family: "Montserrat", sans-serif;
}

.search__suggestionSpan:hover {
  color: black;
  background-color: #e2e2e2;
}

.gallery-wrap {
  padding-top: 0px !important;
  margin-top: 230 px;
}

.ant-spin-dot {
  font-size: 50px;
  width: 50px;
  height: 50px;
  i {
    width: 25px;
    height: 25px;
  }
}

.gallery-wrap {
  .item-search {
    width: 300px !important;
    input {
      padding: 5px 20px;
      padding-right: 50px;
      height: 44px;
      line-height: 44px;
      font-size: 16px;
      border-radius: 100px;
      border-color: #b1b1b1;
      color: #999999;
      &::-webkit-input-placeholder {
        color: #999999;
      }
    }
    .ant-input-suffix {
      right: 20px;
      i {
        font-size: 18px;
      }
    }
  }
}

.menu-list {
  margin-top: 50px;
}

.menu-list-content {
  .filter-part {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    font-family: $main-font;
    margin: 30px 0 70px;
    .filter {
      cursor: pointer;
      i {
        padding-right: 8px;
      }
      font-size: 16px;
      color: #282828;
      font-weight: 500;
      margin-right: 40px;
    }
    .sort {
      font-size: 16px;
      color: #8b8b99;
      display: inline-block;
      .ant-select {
        margin-left: 10px;
      }
    }
  }
}

.filter-content {
  padding: 15px 80px 60px;
  .cross {
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
    .img-wrap {
      width: 18px;
    }
  }
}

.demo {
  .button-group {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding-bottom: 0px;
    button {
      height: 30px;
      margin-bottom: 10px;
      line-height: 28px;
      border: 1px solid #e7e9f3;
      font-size: 13px;
      font-weight: 600;
      border-radius: 30px;
      -moz-background-clip: padding;
      -webkit-background-clip: padding-box;
      background-clip: padding-box;
      padding: 0 20px;
      text-transform: uppercase;
      background-color: transparent;
      -ms-transition: all 500ms ease;
      -webkit-transition: all 500ms ease;
      transition: all 500ms ease;
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
      &.active {
        color: #fff;
        background-color: $brand-color;
      }
      &:hover {
        color: #fff;
        background-color: $brand-color;
      }
      &:focus {
        outline: none;
      }
    }
    &.secondary-filter {
      padding-top: 15px;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        left: 50%;
        top: 0;
        width: 65%;
        height: 1px;
        background: #eaeaea;
        transform: translate3d(-50%, 0, 0);
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .container {
    margin-top: -89px;
  }

  .gallery-wrap {
    .item-search {
      input {
        height: 38px;
        line-height: 38px;
      }
    }
  }
  .menu-list-content {
    .filter-part {
      .sort {
        margin-top: 13px;
      }
    }
  }
  .filter-content {
    padding: 15px 20px 30px;
  }
}
@media only screen and (max-width: 575px) {
  .gallery-wrap {
    .item-search {
      margin-bottom: 20px;
      input {
        height: 35px;
        line-height: 35px;
      }
    }
  }
  .menu-list {
    max-width: 350px;
    margin: 50px auto 0;
  }
  .menu-list-content {
    .filter-part {
      margin: 15px 0 50px;
      .filter {
        margin-right: 20px;
        font-size: 14px;
      }
      .sort {
        margin: 0;
        .info {
          display: none;
        }
        .ant-select {
          margin-left: 0;
          width: 150px !important;
        }
      }
    }
  }
  .demo {
    .button-group {
      button {
        height: 28px;
        line-height: 20px;
        font-size: 12px;
        margin-right: 10px;
        padding: 0 15px;
        text-transform: capitalize;
      }
    }
  }
}
@media only screen and (max-width: 425px) {
  .gallery-wrap {
    .item-search {
      width: 100% !important;
      max-width: 250px;
    }
  }
  .menu-list-content {
    .filter-part {
      margin: 10px 0 40px;
      .filter {
        margin-right: 0px;
      }
    }
  }
  .filter-content {
    padding: 15px 10px 15px;
  }
}

.tagBtn button {
  height: inherit !important;
  border: none !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  border-radius: 0px !important;
  background-clip: padding-box !important;
  padding: 3px 18px !important;
  text-transform: uppercase !important;
  -webkit-transition: all 500ms ease !important;
  transition: all 500ms ease !important;
  margin-right: 0px !important;
  margin-bottom: 7px !important;
  border-right: 1px dashed #ccc !important;
}

.showFilterBar {
  display: block;
  position: relative;
  margin-top: 20px;
  .line {
    border-bottom: 1px dashed #ffffff;
  }
  .text {
    cursor: pointer;
    text-align: center;
    display: inline-block;
    text-transform: uppercase;
    font-weight: bold;
    padding: 8px 20px;
    margin: 0 auto;
    background: #ed2027;
    color: #fff;
    letter-spacing: 2px;
    font-size: 12px;
    border-radius: 200px;
    margin-left: 50%;
    transform: translate(-50%, -50%);
    border: 4px solid #fff;
  }
}
.vname {
  text-align: center;
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 18px;

  span {
    margin: 0;
    font-size: 15px;
    text-transform: uppercase;
    font-weight: bold;
  }
}

.product {
  .image-wrap {
    border-radius: 10px !important;
  }
}

.filters {
  padding: 30px 0px;
  padding-top: 10px;
  background: #fff;
  border-radius: 10px;
  position: relative;
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.2);

  .closeBtn {
    color: rgb(241, 83, 83);
    position: absolute;
    right: 10px;
    top: 10px;
    font-weight: bold;
    cursor: pointer;
  }
}
.searchPage {
  margin-top: 120px !important;
}

.searchbar-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.searchbar-wrapper {
  // border: 1px solid black;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60%;
  align-self: center;
}
.searchbar {
  height: 45px;
  width: 100%;
  border: 1px solid #fff;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 1);
  color: #000;
  padding-left: 20px;
  outline: none;
  font-size: 16px;
  box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.1);
}
.searchbar:focus {
  background-color: rgba(255, 255, 255, 1);
}
.search-icon {
  font-size: 20px;
  position: absolute;
  display: flex;
  align-self: center;
  right: 10px;
}
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #000;
  opacity: 1; /* Firefox */
}
:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #fff;
}
::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #fff;
}
</style>
